import React, { useEffect, useState } from "react";
import axios from "axios";
import { useApp, formatINR } from "../store";

export default function MyOrders() {
  const { API, authHeaders, user } = useApp();
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/orders/mine`, { headers: authHeaders }).then(r => setOrders(r.data));
  }, [API, authHeaders, user]);

  if (!user) {
    return <div className="pt-40 text-center text-[#8A8D8A] font-serif-display text-2xl">Please sign in to view your orders.</div>;
  }

  return (
    <div className="pt-32 pb-24 px-6 md:px-12 max-w-[1200px] mx-auto" data-testid="my-orders-page">
      <div className="overline text-copper mb-4">Your Archive</div>
      <h1 className="headline-xl text-[clamp(3rem,6vw,6rem)] mb-12">My Orders<span className="italic text-[#8A8D8A]">.</span></h1>
      {orders.length === 0 ? (
        <p className="text-[#8A8D8A]">You have not placed any orders yet.</p>
      ) : (
        <div className="divide-y divide-[#E5E1D8] border-y border-[#E5E1D8]">
          {orders.map(o => (
            <div key={o.id} className="py-8 grid md:grid-cols-5 gap-6 items-start" data-testid={`order-${o.id}`}>
              <div className="md:col-span-2">
                <div className="overline text-[10px] text-[#8A8D8A]">Order</div>
                <div className="font-mono text-sm">{o.id.slice(0, 8).toUpperCase()}</div>
                <div className="text-xs text-[#8A8D8A] mt-1">{new Date(o.created_at).toLocaleDateString()}</div>
              </div>
              <div>
                <div className="overline text-[10px] text-[#8A8D8A]">Items</div>
                <div className="text-sm">{o.items.reduce((s, i) => s + i.quantity, 0)} pieces</div>
              </div>
              <div>
                <div className="overline text-[10px] text-[#8A8D8A]">Status</div>
                <span className={`inline-block text-[10px] uppercase tracking-widest px-2 py-1 ${o.status === "paid" || o.status === "paid_sandbox" ? "bg-[#3C6348]/10 text-[#3C6348]" : "bg-[#EBE4D8] text-[#5C5E5C]"}`}>
                  {o.status.replace("_", " ")}
                </span>
              </div>
              <div className="text-right">
                <div className="overline text-[10px] text-[#8A8D8A]">Total</div>
                <div className="font-serif-display text-xl">{formatINR(o.total)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
